import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import EditVisitActionForm from '../Forms/EditVisitActionForm';
import { AppModalHeader } from '../../common/AppModalHeader';
import useModalForm from '../../common/Hooks/useModalForm';
import { createFakeId } from '../../../reducers/util';

const EditVisitActionModal = ({ children, className }) => {
    const { toggle, isOpen, formValue, openModal } = useModalForm();

    return (
        <>
            {isOpen ? (
                <Modal isOpen={isOpen} toggle={toggle} className={className}>
                    <AppModalHeader toggle={toggle}>
                        {formValue.visitActionId < 0 ? 'Create Visit Action' : 'Edit Visit Action'}
                    </AppModalHeader>
                    <ModalBody>
                        <EditVisitActionForm onCancel={toggle} {...formValue} />
                    </ModalBody>
                </Modal>
            ) : null}
            {children({
                editVisitAction: visitAction => openModal(visitAction),
                createVisitAction: (companyId, parentCommunicationId) =>
                    openModal({ companyId, parentCommunicationId, visitActionId: createFakeId() })
            })}
        </>
    );
};

export default EditVisitActionModal;
